// Colors
// import { primary } from '../../../common/colors';
import palette from '../palette';

export default {
  root: {
    backgroundColor: palette.background.default,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8
  }
};
